function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlphaTrader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 20L8.08707 5.93579L9.81137 8.91632L3.3957 20H0Z",
    fill: "#5B5B5B",
    style: {
      fill: "#5B5B5B",
      fill: "color(display-p3 0.3584 0.3584 0.3584)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73085 19.9996L13.1832 8.83037L9.77241 2.99229L11.5162 0L23 19.9996H19.6982L14.9097 11.8098L10.1266 19.9996H6.73085Z",
    fill: "#5B5B5B",
    style: {
      fill: "#5B5B5B",
      fill: "color(display-p3 0.3584 0.3584 0.3584)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4794 19.9913H16.1787L14.8301 17.6599L13.4794 19.9913Z",
    fill: "#5B5B5B",
    style: {
      fill: "#5B5B5B",
      fill: "color(display-p3 0.3584 0.3584 0.3584)",
      fillOpacity: 1
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphaTrader);
export default __webpack_public_path__ + "static/media/AlphaTrader.d4cdf83136fa52a1a9307d534e477ddf.svg";
export { ForwardRef as ReactComponent };